const common_resource = "/resource/swiftapp/";
export const Content_Endpoint = common_resource+"getContent";
export const TokenGen_Endpoint = "/resource/oAuth/tokenGen?cname=";
export const Audit_Log = common_resource+"newcard-lead-audit-log";
export const Sbicard_Details = "/resource/eapply-api/cardDetails/fetch-sbicard-details?path=";
export const DownsellCard_Details = common_resource+"newcard-lead-card-update";
export const Lead_Ecard = common_resource+"newcard-lead-ecard";
export const Validate_Referral = "/resource/managereferrals/validate-referral";
export const Get_Master_Data =  common_resource+"getMasterData";
export const Lead_Submission =  common_resource+"newcard-lead-submission";
export const Otp_Gen =  common_resource+"esb-otp-gen";
export const Lead_Dedupe =  common_resource+"newcard-lead-dedupe";
export const Lead_Pd_Credit =  common_resource+"newcard-lead-pd-credit";
export const Lead_Photo_Match =  common_resource+"newcard-lead-photo-match";
export const Get_Card_Usage_Details =  common_resource+"newcard-lead-get-card-usage-details";
export const Update_Card_Usage_Details =  common_resource+"newcard-lead-update-card-usage-details";
export const Lead_Pd_Paylink = common_resource+"newcard-lead-pd-paylink";
export const Lead_Retrieve = common_resource+"newcard-lead-retrieve";
export const Lead_Create = common_resource+"newcard-lead-create";
export const Lead_Update = common_resource+"newcard-lead-update";
export const Lead_Ingestion_Two = common_resource+"newcard-lead-ingestion-2";
export const Lead_Track_Auth = common_resource+"newcard-lead-track-auth";
export const Upload_File_Do = "/safe/upload-file.do";
export const Lead_Digilocker_Pull = common_resource+"newcard-lead-digilocker-pull";
export const Lead_digilocker_search = common_resource+"newcard-lead-digilocker-search";
export const Create_Order = common_resource+"createOrder";
export const CAD_Address_Confirm = common_resource+"newcard-lead-cad-submit";
export const Partner_Bank_Ingest = common_resource+"newcard-bank-ingest";
export const Lead_Consent_Update = common_resource+"newcard-leadconsent-update";
export const Off_Hrs = common_resource+"newcard-lead-vkyc-validation";
export const Partner_Non_Bank_Ingest = common_resource+"newcard-ext-bank-ingest";
export const Get_Products_Data = common_resource+"getProductMasterData";
export const Telco_Otp_Gen = common_resource+"telco-otp-gen";
export const Telco_Otp_Verify = common_resource+"verify-telco-otp";
export const Income_Select_Surrogate = common_resource+"newcard-lead-account-aggregator";
export const Income_Select_Surrogate_Gst = common_resource+"newcard-lead-surrgst"
export const Epfo_Otp_Gen = common_resource+"epfo-otp-gen";
